let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("LclDr")).then(() => parcelRequire('d2zPy'));